module.exports = __webpack_public_path__ + "images/ae165fb597e516fbb3b3a97fa98f4cfc-bg-soft.png";